import React, { useEffect, useState } from 'react';
import { Skeleton } from '@/components/ui/skeleton';

function SkeletonCard() {
  return (
    <div className="rounded-lg border px-3 py-2.5 space-y-1.5">
      {/* Top row: avatar + name + badge */}
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <Skeleton className="h-6 w-6 rounded-full" />
          <div className="space-y-1">
            <Skeleton className="h-2.5 w-24" />
            <Skeleton className="h-2 w-16" />
          </div>
        </div>
        <div className="flex items-center gap-2">
          <Skeleton className="h-3.5 w-10 rounded-full" />
          <Skeleton className="h-5 w-10 rounded-full" />
          <Skeleton className="h-7 w-12 rounded-md" />
        </div>
      </div>
      {/* Score bar */}
      <Skeleton className="h-1 w-full rounded-full" />
    </div>
  );
}

export function RecommendationLoadingState() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setShow(true), 200);
    return () => clearTimeout(timer);
  }, []);

  if (!show) return null;

  return (
    <div className="space-y-1.5">
      <SkeletonCard />
      <SkeletonCard />
      <SkeletonCard />
    </div>
  );
}
